import React from 'react';
import {AgeGroup} from '@guestapp/sdk';
import {AGE_USER_TYPE} from 'utils/constants';
import {NAVIGATION_STATUSES} from 'components/NavigationPanel/useBuildNavigationItems';
import {useSummary} from 'context/summary';
import {useModalControls} from 'hooks';
import {WhoComingModalSheet} from './WhoComingModalSheet';

type useWhoIsCommingModalProps = {
  showFirstTime?: boolean;
  openModalPerSession?: boolean;
};

function useWhoIsCommingModal({
  openModalPerSession,
  showFirstTime,
}: useWhoIsCommingModalProps = {}) {
  const {data} = useSummary();
  const {
    isOpen: isOpenConfirmModal,
    closeModal: closeConfirmModal,
    openModal: openConfirmModal,
  } = useModalControls();
  const yearsAbove = data?.booking?.age_group.find(
    (ag: AgeGroup) => ag?.name === AGE_USER_TYPE.adult,
  );

  React.useEffect(() => {
    if (showFirstTime) {
      const isProcessComplete =
        data?.guest_registration?.status === NAVIGATION_STATUSES.complete;
      if (openModalPerSession && !isProcessComplete) openConfirmModal();
      return;
    }
  }, [
    openModalPerSession,
    openConfirmModal,
    data?.guest_registration?.status,
    showFirstTime,
  ]);

  const modal = React.useCallback(
    () => (
      <WhoComingModalSheet
        isOpenWhoComingModalSheet={isOpenConfirmModal}
        handleCloseModal={closeConfirmModal}
        yearsAbove={yearsAbove?.base_age}
      />
    ),
    [isOpenConfirmModal, closeConfirmModal, yearsAbove?.base_age],
  );

  return {
    isOpen: isOpenConfirmModal,
    closeModal: closeConfirmModal,
    openModal: openConfirmModal,
    modal,
  };
}

export {useWhoIsCommingModal};
